export const SELECTION_CENTRAL_ATTRIBUTES =
  "asin%2Citem_name%2Crtip_product_line%2Cgl_product_group_type%2Cproduct_category%2Cproduct_subcategory";
export const PPLS_REQUEST_ACCESS =
  "https://sim.amazon.com/issues/create?template=3188bb91-1111-434c-b6ff-6935e91f07e9";
